/**
 * 按钮组件
 */
import React from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import { getIntl } from '@/locales';
import { ButtonProps } from '@/types';

export default function Button(props: ButtonProps) {
  const intl = getIntl();
  return (
    <div
      className={classnames(props.className, styles.determine_btn, {
        [styles.disable]: props.disabled,
        [styles.line]: props.type === 'line',
      })}
      style={props.style}
      onClick={() => {
        if (props.disabled || props.loading) return;
        props.onClick?.();
      }}
    >
      {props.loading ? (
        <div className={styles['spin-overlay']}>
          <div className={styles['spin-spinner']} />
        </div>
      ) : (
        props.btnText || intl.formatMessage({ id: 'iWeb.Inputs.InputBox.Confirm', defaultMessage: '確認' })
      )}
    </div>
  );
}
